import { RootState } from '@src/store';

export const selectConfirm = (state: RootState) => state.ConfirmReducer;
